import { api } from "../../api";
import {
  RequestActivePricesParams,
  ActivePricesResponse,
  PassivePricesResponse,
  RequestPricePackagesParams,
  PricesPackagesResponse,
  MarginResponse,
  RequestMarginParams,
} from "./types";

export async function getActivePricesApi(
  params: RequestActivePricesParams,
): Promise<ActivePricesResponse> {
  const { data } = await api.get<ActivePricesResponse>("/api/prices/active", {
    params,
  });
  return data;
}

export async function getPassivePricesApi(
  params: RequestActivePricesParams,
): Promise<PassivePricesResponse> {
  const { data } = await api.get<PassivePricesResponse>("/api/prices/passive", {
    params,
  });
  return data;
}

export async function getMacrosPricesApi(
  params: RequestPricePackagesParams,
): Promise<PricesPackagesResponse> {
  const { data } = await api.get<PricesPackagesResponse>(
    "/api/prices/active/packages",
    {
      params,
    },
  );
  return data;
}

export async function calculateMarginApi(
  params: RequestMarginParams,
): Promise<MarginResponse> {
  const { data } = await api.post<MarginResponse>(
    "/api/offers/calculate/margin",
    {
      ...params,
    },
  );
  return data;
}
